import { render, staticRenderFns } from "./InformationMeasure.vue?vue&type=template&id=3b0b5038&"
import script from "./InformationMeasure.vue?vue&type=script&lang=js&"
export * from "./InformationMeasure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports